import { createFileRoute } from "@tanstack/react-router";
import { AdminListingApprovalPage } from "@/components/AdminListingApproval";

export const Route = createFileRoute("/_authenticated/admin/listings/approved")({
  head: () => ({
    meta: [
      { title: "Approved Listings · Landoo Admin" },
      { name: "description", content: "Approved listings currently live on the public map." },
    ],
  }),
  component: () => <AdminListingApprovalPage status="published" />,
});
